import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ClienteService } from '../../services/cliente/cliente.service';

@Injectable()
export class ClienteGuardService implements CanActivate {

  constructor(private clienteService: ClienteService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.clienteService.getfiltroBuscarCliente() ? true : false;
  }



}



// WEBPACK FOOTER //
// ./src/app/guards/cliente-guard/cliente-guard.service.ts